import React from 'react'
import { Box, Typography, Chip, Divider, Stack } from "../../../imports/muiImport";
import RedeemableProduct from '../redeemableProducts/RedeemableProduct';
import ProductDetailPara from './ProductDetailPara';
import { useSelector } from 'react-redux';
import MarkdownRenderer from './MarkdownRenderer';

const normalizeContent = (input) => {
    if (!input) return '';
    return input
        .replace(/<br\s*\/?>/gi, '\n')  // Convert <br> to \n
        .replace(/\r\n|\r|\n/g, '\n'); // Normalize all newlines
}

function MobileProductDetails({ product }) {
    const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
    return (
        <Box mt={3} sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            maxWidth: '100%',
        }}>
            <Typography variant='h1'
                sx={{
                    color: "text.primary",
                    fontSize: { xs: "4.5vw", sm:'2.5vw' },
                    fontWeight: 500,
                    textAlign: "center",
                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                    mb: 2,
                    px: 2,
                }}
            >
                {product?.title}
            </Typography>

            <Chip label={`${PRODUCTDETAILS?.discount}% ${PRODUCTDETAILS?.productType}`}
                sx={{
                    px: "4px",
                    backgroundColor: "primary.main",
                    color: "white.main",
                    fontSize: {
                        xs: "3.8vw",
                        sm: '2vw'
                    },
                    boxShadow: 6,
                    mb: 1
                }}
            />

            <Box sx={{
                py: 2,
                borderRadius: 3,
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "column",
                alignItems: "center",
            }}>
                <Typography variant='body1' sx={{
                    mb: 1,
                    color: "text.primary",
                    fontSize: {
                        xs: "4.1vw",
                        sm: '2vw'
                    },
                    fontWeight: 500,
                    textTransform: 'capitalize'
                }}>
                    Redeemable at:
                </Typography>
                <RedeemableProduct store={product?.store} website={product?.website} />
                <Typography variant='h2' sx={{
                    mt: 2,
                    color: "textPrimary.main",
                    fontSize: {
                        xs: "3.1vw",
                        sm: '2vw'
                    },
                }}>
                    *Terms & Condtions apply
                </Typography>
            </Box>

            <ProductDetailPara productDescription={normalizeContent(product?.description)} />

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    rowGap: 3,
                    maxWidth: '100%'
                }}
            >
                {product?.redeem?.length > 0 && (
                    <Stack direction="column" sx={{ borderBottom: 1, borderColor: 'borderColor.main' }}>
                        <Typography
                            variant="h2"
                            sx={{
                                color: "primary.main",
                                fontSize: "1.225rem",
                                textAlign: "left",
                                fontWeight: 500
                            }}
                        >
                            How to Redeem
                        </Typography>

                        <MarkdownRenderer content={product?.redeem} />
                    </Stack>
                )}


                {product?.terms?.length > 0 &&
                    (
                        <Stack direction='column' sx={{ borderBottom: 1, borderColor: 'borderColor.main' }}>
                            <Typography variant='h2'
                                sx={{
                                    color: "primary.main",
                                    fontSize: "1.225rem",
                                    textAlign: 'left',
                                    fontWeight: 500
                                }}
                            >
                                Terms & Condtions
                            </Typography>
                            <MarkdownRenderer content={product?.terms} />
                        </Stack>
                    )
                }

                {product?.['moreInfo']?.length > 0 &&
                    (
                        <Stack direction='column'>
                            <Typography variant='h2'
                                sx={{
                                    color: "primary.main",
                                    fontSize: "1.225rem",
                                    textAlign: 'left',
                                    fontWeight: 500
                                }}
                            >
                                More Info
                            </Typography>
                            <MarkdownRenderer content={product?.['moreInfo']} />
                        </Stack>
                    )
                }
            </Box>
        </Box>
    )
}

export default MobileProductDetails